import AuthComponent from "@components/auth/component";
import BackButton from "@components/buttons/BackButton";
import CustomButton from "@components/buttons/CustomButton";
import CustomFileField from "@components/form/CustomFileField";
import { LoadingSpinner } from "@components/layouts/LoadingSpinner";
import PageWrapper from "@components/layouts/PageWrapper";
import { Toast } from "@helpers/popups/Toast";
import { useErrorHandling } from "@hooks/useErrorHandling";
import { useCreateBannerMutation } from "@states/others/banner.api";
import { TFailResponse } from "@type-defs/general/TFailResponse";
import { BANNER } from "@utils/constants/others/banner.constants";
import { castTypeArr } from "@utils/general/cast-type";
import React, { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

function BannerAddPage() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError,
    watch,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm<any>({});
  const [createBanner, { data, isSuccess, isLoading, error: createError }] =
    useCreateBannerMutation();

  useErrorHandling(...castTypeArr<TFailResponse>([createError]));

  useEffect(() => {
    if (isSuccess && data) {
      Toast.fire({
        title: data.message,
        icon: "success",
      });

      navigate(BANNER.BASE_PATH, {
        state: {
          reload: true,
        },
      });
    }
  }, [isSuccess, data, navigate]);

  const onSubmit: SubmitHandler<any> = async (data) => {
    try {
      const formData = new FormData();
      const bannerImage = data.banner_image?.[0];

      if (bannerImage) {
        formData.append("banner_image", bannerImage);
        await createBanner(formData);
      } else {
        Toast.fire({
          title: "Banner Image is Required",
          icon: "error",
        });
      }
    } catch (error: any) {
      setError("root", {
        message: error.message,
      });
    }
  };

  return (
    <AuthComponent action="create" module="Others" subModule="Banner" page>
      <PageWrapper>
        {isLoading && <LoadingSpinner />}
        <BackButton />
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="mb-4 ml-2 text-2xl font-[600] uppercase text-primary-dark">
            {BANNER.ADD_NEW_TITLE}
          </h3>

          <CustomFileField
            label="Banner Image"
            placeHolder="Banner Image here"
            errors={errors}
            name="banner_image"
            register={register}
            setValue={setValue}
            watch={watch}
          />

          <div className="ml-2 mt-14">
            <CustomButton
              isLarge
              title="Cancel"
              color="white"
              textColor="gray.800"
              className="mr-10"
              handleClick={() => navigate(-1)}
            />
            <CustomButton
              handleClick={handleSubmit(onSubmit)}
              isLarge
              title={isSubmitting ? "Loading..." : "Submit"}
              disabled={isSubmitting}
              type="submit"
            />
          </div>

          {errors.root && (
            <div className="mt-6 text-red-500">{errors.root.message}</div>
          )}
        </form>
      </PageWrapper>
    </AuthComponent>
  );
}

export default BannerAddPage;
